import {
  ContextService,
  JwtService,
  RequestHeaderService,
} from "globals/helpers";
import {
  addToInquiryUrl,
  baseInquiryUrl,
} from "frontend-kit/organisms/f-header/f-inquiry-flyout/f-inquiry-config";
import { ErrorResponseWrapper } from "@apis/errors/error-response-wrapper";
import InquiryCart from "api/model/inquiry/inquiry-cart";
import { createStore } from "@stencil/store";

interface InquiryStore {
  inquiriesCart: InquiryCart;
  is: "LOADING" | "LOADED" | "ERROR";
}

interface AddToInquiryCartResponse {
  inquiryCart: InquiryCart;
}

const { state, set, get } = createStore({
  inquiriesCart: {},
} as InquiryStore);

export const getInquiryData = async () => {
  set("is", "LOADING");
  fetchInquiries()
    .then(async (response) => {
      set("inquiriesCart", response);
    })
    .catch(handleErrors)
    .finally(() => set("is", "LOADED"));
};

export function addToInquiry(
  productCode: string,
  quantity: number
): Promise<InquiryCart> {
  const headers = RequestHeaderService.getHeadersWithJwt();
  return fetch(addToInquiryUrl, {
    method: "POST",
    ...headers,
    body: JSON.stringify({
      productCode,
      quantity,
    }),
  }).then(async (response) => {
    if (!response.ok) {
      handleErrors();
      throw new ErrorResponseWrapper(response);
    }
    const responseData: AddToInquiryCartResponse = await response.json();
    set("inquiriesCart", responseData.inquiryCart);
    return responseData.inquiryCart;
  });
}

async function fetchInquiries(): Promise<InquiryCart> {
  if (!JwtService.isJwtValid() && !ContextService.isAnonymous()) {
    await JwtService.updateJwt();
  }
  const url = `${baseInquiryUrl}`;
  const headers = RequestHeaderService.getHeadersWithJwt();
  return fetch(url, { method: "GET", ...headers }).then((response) => {
    if (!response.ok) {
      handleErrors();
      throw new ErrorResponseWrapper(response);
    }
    return response.json();
  });
}

const handleErrors = () => {
  set("is", "ERROR");
};

export { get, set };
export default state;
